import { startEndDateFromTimeRange } from "../../../../utils/timeUtils";
import { OperatorPanelWrapperFullSize } from "../../../components/Layout";
import { PortfolioEnergyChart } from "../PortfolioEnergyChart";
import { useState } from "react";
import { Button } from "baseui/button";
import { ButtonGroup } from "baseui/button-group";
import { FormattedMessage } from "react-intl";
import { IPortfolioEnergyChart } from "../PortfolioEnergyChart/types";
import { ParagraphMedium } from "baseui/typography";
import { themedUseStyletron } from "../../../../theme/customTheme";
import { filterCounters, getColor, getDisplayMode, getUnitFromDisplayMode } from "./utils";
import { Name } from "./OverviewPanel";
import { CounterMedium } from "../../../Devices/CounterMedium";
import { DisplayMode } from "../../../../hooks/useGetBuildingsEnergy";
import TotalOrSqmSelector from "../components/TotalOrSqmSelector";

const OperatorPanel = (props: IPortfolioEnergyChart) => {
    const [css, theme] = themedUseStyletron();
    const { start, end } = startEndDateFromTimeRange(props.timeRange);
    const [sqm, setSqm] = useState(props.byM2)

    const counterMediumFilter = props.counterMediumFilter;
    const color = getColor(counterMediumFilter, theme);
    const displayMode = getDisplayMode(counterMediumFilter);

    const convertToMWh = displayMode === DisplayMode.KWH && !props.byM2;
    const valueFactor = convertToMWh ? 0.001 : 1;
    const dimension = convertToMWh ? "MWh" : getUnitFromDisplayMode(displayMode);

    return (
        <OperatorPanelWrapperFullSize objectId={props.id}
            {...props}
            statusContent={<>
                <div className={css({ display: 'flex', flexDirection: 'row', alignItems: 'baseline', justifyContent: 'space-between', width: '100%' })} >
                    <ParagraphMedium margin={0}><Name hideNumItems displayMode={displayMode} {...props} start={start} end={end}></Name></ParagraphMedium>

                    <div className={css({ alignSelf: 'flex-end' })}>
                        <TotalOrSqmSelector byM2={props.byM2} onByM2Changed={(v) => setSqm(v)}/>
                    </div>
                </div>
            </>} >

            <PortfolioEnergyChart valueFactor={valueFactor} dimension={dimension} medium={counterMediumFilter} filterCounters={(v) => filterCounters(v, counterMediumFilter)} colors={[color]} color={theme.colors.primary} byM2={sqm} start={start} end={end} take={1000} displayMode={displayMode} ></PortfolioEnergyChart>

        </OperatorPanelWrapperFullSize>
    )
}

export default OperatorPanel;

